<template>
  <div>
    <div class="app-inner-body-content">
      <Hero>
        {{ $t('message.testDrive.chooseLocation.heading') }}
        <img :src="require('@/assets/red-pin.svg')" alt="" width="24" height="24" class="mb-1 ml-0" />
        <template slot="description">{{
          $t('message.testDrive.chooseLocation.msg', { businessName: this.$store.state.business.info.name })
        }}</template>
      </Hero>
      <MobialisFormWithValidation ref="form" v-slot="{ invalid, errors }" @onValidate="submit">
        <p class="error" v-if="invalid">{{ $t('message.testDrive.chooseLocation.errorNoLocation') }}</p>
        <RouteRadio
          :options="availableLocations"
          oneColumn
          v-model="chosenLocation"
          name="choose-location"
          error="$t('message.testDrive.pickLocationError')"
        />
      </MobialisFormWithValidation>
    </div>
    <mobialis-button class="mt-5" @click="triggerSubmit" data-cy="continueBtn">{{
      $t('message.common.continue')
    }}</mobialis-button>
  </div>
</template>
<script>
import Hero from '@/components/test-drive/Hero.vue';
import RouteRadio from '@/components/test-drive/RouteRadio.vue';

export default {
  name: 'ChooseLocation',
  components: {
    Hero,
    RouteRadio,
  },
  data() {
    return {
      availableLocations: [
        {
          label: this.$t('message.testDrive.chooseLocation.fromHomeLabel'),
          description: this.$t('message.testDrive.chooseLocation.fromHomeMsg'),
          value: 'home',
        },
        {
          label: this.$t('message.testDrive.chooseLocation.fromDealershipLabel'),
          description: this.$t('message.testDrive.chooseLocation.fromDealershipMsg'),
          value: 'dealership',
        },
      ],
    };
  },
  computed: {
    chosenLocation: {
      get() {
        return this.$store.state.testDrive.chosenLocation;
      },
      set(value) {
        this.$store.commit('testDrive/SET_CHOSEN_LOCATION', value);
        if (value === 'home') {
          this.$store.commit('testDrive/SET_CHOSEN_ROUTE', value);
        } else {
          this.$store.commit('testDrive/SET_CHOSEN_ROUTE', null);
        }
      },
    },
  },
  methods: {
    submit(isValid) {
      if (isValid) {
        this.$router.push({
          name: `drive-choose-date-${this.baseRoute}`,
        });
      }
    },
    triggerSubmit() {
      this.$refs.form.submit();
    },
  },
};
</script>

<style lang="scss" scoped></style>
